import AlertWidget from './AlertWidget';
import { connect } from 'react-redux';
import { IApplicationState } from 'ducks/reducers';
import { selectors as customerSelectors } from 'ducks/customer';
import { selectors as productSelectors } from 'ducks/SearchLookUp/productLookup';
import { selectors as pickSlipSelectors } from 'ducks/pickSlips/pickSlipTransaction';

const mapStateToProps = (state: IApplicationState) => ({
  selectedCustomer: customerSelectors.selected(state)?.CustomerId,
  selectedProduct: productSelectors.selected(state)?.ProductId,
  selectedPickSlip: pickSlipSelectors.selected(state),
});

export default connect(mapStateToProps, null)(AlertWidget);
